import {
	// 获取国家
	fetchNationsApi,
	// 获取车辆类型
	fetchVehicleModelsApi,
	// 获取集装箱类型
	fetchContainerTypesApi,
	// 获取包装类型
	fetchPackageTypesApi,
	// 获取运输方式
	fetchCarriageTypesApi,
	// 获取公司主营业务
	fetchCompanyBusinessApi,
//
	fetchErpTypeApi
} from '@/apis-global/ins.js'
export default {
	async initData({commit}) {
		let loop = true
		while (loop) {
			try {
				const [countries, vehicles, containers, packages, carriages, business, erpTypes] = await Promise.all([
					fetchNationsApi(),
					fetchVehicleModelsApi(),
					fetchContainerTypesApi(),
					fetchPackageTypesApi(),
					fetchCarriageTypesApi(),
					fetchCompanyBusinessApi(),
					fetchErpTypeApi()
				])
				commit('SET_COUNTRIES', countries)
				commit('SET_VEHICLES', vehicles)
				commit('SET_CONTAINERS', containers)
				commit('SET_PACKAGES', packages)
				commit('SET_CARRIAGES', carriages)
				commit('SET_BUSINESS', business)
				commit('SET_ERPTYPES', erpTypes)
				loop = false
			} catch (e) {console.log(e)}
			if (loop) {
				await new Promise(resolve => setTimeout(resolve, 2000))
			}
		}
	}
}